export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_CHECK_FAIL = 'AUTH_CHECK_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_START_CHECKING = 'AUTH_START_CHECKING';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';

export const AUTH_MFA_REQUIRED = 'AUTH_MFA_REQUIRED';
export const AUTH_MFA_CANCEL = 'AUTH_MFA_CANCEL';
export const AUTH_MFA_SUBMIT_FAIL = 'AUTH_MFA_SUBMIT_FAIL';
export const AUTH_MFA_SETUP_READY = 'AUTH_MFA_SETUP_READY';